<template>
  <div @click="gotoPart" class="item-container">
    <div class="img-container d-img-container">
      <img @load="calculateImg" alt="pic" v-if="getImg" :src="getImg" />
      <div class="enlarge-icon" v-if="getImg">
        <EnlargeIcon @click.stop="onImgClick" />
      </div>
      <div v-if="!getImg" class="no-img">{{ $t('common.no_img') }}</div>
    </div>

    <div class="item-info">
      <div class="j-content part-name j-might-overflow">
        {{ item.partName ? $t(item.partName) : '' }}
        <!-- {{ item.modelNum ? `(${item.modelNum})` : '' }} -->
      </div>
    </div>

    <PreviewImageModal
      @after-close="handleAfterClose"
      v-if="showPreviewModal"
      :images="previewImg"
    />

    <MultiStatusModal
      @after-close="handleAfterMultiStatusClose"
      v-if="showMultiStatusModal"
      :item="item"
      :type="1"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { baseFileUrl } from '@/utils/constants';
import MultiStatusModal from '@/components/multi-status/MultiStatusModal.vue';

interface DiagramItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'CatalogueItem',
  components: {
    EnlargeIcon,
    PreviewImageModal,
    MultiStatusModal
  },
  data(): DiagramItemProps {
    return {
      baseFileUrl,
      showPreviewModal: false,
      previewImg: [],
      showMultiStatusModal: false
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    prePageNo: {
      type: Number,
      required: true,
      default: () => {
        return 1;
      }
    },
    vehicleId: {
      type: Number,
      required: true,
      default: () => {
        return 1;
      }
    }
  },
  computed: {
    getImg() {
      let res = '';
      const partsImgs = this.item.partsImgs || [];

      if (partsImgs.length > 0) {
        if (partsImgs[0].fileUrl) {
          res = baseFileUrl + partsImgs[0].fileUrl;
        }
      }

      return res;
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.d-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    onImgClick() {
      this.previewImg.push(this.getImg);
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    async handleAfterMultiStatusClose(data, isCancel) {
      this.showMultiStatusModal = false;
      if (isCancel) {
        return;
      }
      if (data) {
        localStorage.setItem('diagramPageNo', this.prePageNo.toString());
        this.$router.push(`/part-detail/${data.diagramId}/${this.vehicleId}`);
      }
    },
    gotoPart() {
      if (this.item.differentStatus === 1) {
        this.showMultiStatusModal = true;
      } else {
        localStorage.setItem('diagramPageNo', this.prePageNo.toString());
        this.$router.push(`/part-detail/${this.item.id}/${this.vehicleId}`);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 1px;
  border: 1px solid $secondary-color2;

  .item-info {
    background-color: $secondary-color1;
    padding: 14.5px 20px;

    .part-name {
      font-weight: bold;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &:hover {
    border: 1px solid $primary-color;
    transition: border 0.5s;

    .item-info {
      transition: all 0.5s;
      background-color: $primary-color;
      .part-name {
        color: white;
      }
    }
  }

  .img-container {
    cursor: pointer;
    position: relative;

    .enlarge-icon {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .no-img {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
